import { render, staticRenderFns } from "./AvatarUploadModal.vue?vue&type=template&id=88690d0e&scoped=true&"
import script from "./AvatarUploadModal.vue?vue&type=script&lang=js&"
export * from "./AvatarUploadModal.vue?vue&type=script&lang=js&"
import style0 from "./AvatarUploadModal.vue?vue&type=style&index=0&id=88690d0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88690d0e",
  null
  
)

export default component.exports